export const report = {
  driverReport: "司机工作状况报表",
  vehicleReport: "设备使用效率报表",
  alertReport: "告警统计报表",
  dailyReport: "日报表",
  monthReport: "月报表",
  yearReport: "年报表",
  defineDate: "自定义日期",
  searchReport: "生成报表",
  exportReport: "导出数据",
  vehicleUsage: "使用效率 | 使用效率",
  vehicleHours: "移动时长 | 移动时长(小时)",
  vehicleOnlineHours: "在线时长 | 在线时长(小时)",
  vehicleDistances: "搬运里程 | 搬运里程(公里)",
  vehicleUsageTitle: "设备使用效率",
  vehicleUsageRate: "设备使用效率",
  vehicleOnlineRate: "设备在线率",
  vehicleHoursAndDistance: "设备移动时长",
  vehicleReportTitle:
    "{department} 设备使用效率报表（{start} 到 {end}）| {department} 设备使用效率报表（{start}）",
  detail: "详情",
  detailInfo: "详细信息",
  detailInfoShow: "详细数据显示",
  driverReportTitle:
    "{department} 司机工作统计报表（{start} 到 {end}） | {department} 司机工作统计报表（{start}）",
  driverHours: "工作时长 | 工作时长(小时)",
  driverDistances: "搬运里程 | 搬运里程(公里)",
  lastMonth: "过去30天",
  lastWeek: "过去7天",
  vehicleUsageRateAvg: "设备使用效率平均值",
  driverWorkDistanceAvg: "搬运里程平均值(公里)",
  usageInfoTips: "使用效率 = 移动时长(小时) / 在线时长(小时)",
};
